import { VideoYoutube } from '@components/video-youtube/models';
import { Block } from '@shared/models';

export const videoYoutubeMock: Block<VideoYoutube> = {
  type: 'video-youtube',
  data: {
    link: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    legend: `Les 3 grandes étapes pour préparer la pose de votre cuisine équipée`,
  },
};
